// Styles
import "../styles/Footer.css";
// Third-Party =====> bootstrap
import { Container, Row, Col, Button } from "react-bootstrap";
// API
import { useGetSettingsQuery } from "../redux/features/home/homeApiSlice";
// Icons
import {
   faPhone,
   faEnvelope,
   faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Images
import logo from "../assets/logo.png";
import QRCode from "../assets/Group 18020.png";

function Footer() {
   // ################### RTK QUERY ###################
   const { data: settings, isSuccess } = useGetSettingsQuery();

   // ################### CONTENT ###################
   let content;
   if (isSuccess) {
      const { data: info } = settings;
      content = (
         <Col sm={6} md={3} className="second-col">
            <h3 className="footer-header">تواصل معنا</h3>

            <ul>
               <li>
                  <FontAwesomeIcon icon={faLocationDot} />
                  {info?.the_country} / {info?.the_city}
               </li>
               <li>
                  <FontAwesomeIcon icon={faPhone} />
                  {info?.the_phone}
               </li>
               <li>
                  <FontAwesomeIcon icon={faEnvelope} />
                  {info?.the_email}
               </li>
               <li>
                  <h4>اوقات العمل</h4>
                  <span>{info?.hours_work}</span>
               </li>
            </ul>
         </Col>
      );
   }

   return (
      <div className="footer-comp">
         <Container>
            <Row className="justify-content-between ">
               <Col md={4} className="first-col">
                  <img src={logo} alt="" />
                  <p>
                     شركة خدمات ERP لإدارة و تخطيط موارد المؤسسات مع خدمة الربط
                     الالكتروني المعتمد من وزارة المالية
                  </p>
                  <Button className="how-we-are" href="/#about">
                     من نحن
                  </Button>
               </Col>
               {content}
               <Col sm={6} md={2} className="third-col">
                  <h3 className="footer-header">وصول سريع</h3>
                  <ul>
                     {/* <li>حول الشركة</li> */}
                     <li>ميزاتنا</li>
                     <li>الخدمات</li>
                     <li>اعمالنا</li>
                     <li>تواصل معنا</li>
                  </ul>
               </Col>
               <Col md={3} className="align-self-center last-col">
                  <img src={QRCode} alt="qrCode" />
                  {/* <div className='alert'>
                            Scan It
                        </div> */}
               </Col>
            </Row>
         </Container>
      </div>
   );
}

export default Footer;
